import React, { useState } from 'react';
import { Paper, Tab, Tabs } from '@material-ui/core';

import { TabPanel } from 'shared';

import { CreatePackaging } from './createPackaging';
import { ViewPackaging } from './viewPackaging';

function Packaging({ baseUrl }) {
    const [selectedTab, setSelectedTab] = useState('0');
    const handleChange = (event, value) => {
        setSelectedTab(value);
    };

    return (
        <Paper>
            <Tabs onChange={handleChange} value={selectedTab} indicatorColor="primary" textColor="primary" centered>
                <Tab id="ViewPackagin_Tab" label="View Packaging" value="0" />
                <Tab id="CreatePackaging_Tab" label="Create Packaging" value="1" />
            </Tabs>
            <TabPanel selectedTab={selectedTab} index="0">
                <ViewPackaging />
            </TabPanel>
            <TabPanel selectedTab={selectedTab} index="1">
                <CreatePackaging />
            </TabPanel>
        </Paper>
    );
}

export { Packaging };
